module.exports = __webpack_public_path__ + "static/media/image-user.c3ed053e.jpg";